import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import ThemeContext from '../../utils/theming';
import { widthEm, isPortrait } from '../../utils/size';

const Button = styled.button`
    height: ${props => (props.height ? props.height : 88)}px;
    line-height: ${props => (props.height ? props.height : 88)}px;
    border-radius: 4px;
    border: solid 1px #f1f1ee;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    cursor: pointer;
    background-color: #fff;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 1);
    width: 100%;

    &:active {
        background-color: ${({ theme }) => theme.colors.primary};
        border: solid 1px ${({ theme }) => theme.colors.primary};
        color: #fff;
        span {
            color: #fff;
        }
    }

    ${({ theme }) =>
        !isPortrait() &&
        `
            &:hover {
                background-color: ${theme.colors.primary};
                border: solid 1px ${theme.colors.primary};
                color: #fff;
                span {
                    color: #fff;
                }
            }
        `};

    ${() =>
        widthEm() < 30 &&
        `
            flex-direction: column;
            margin: 0 0 12px;
            min-height: 70px;
            max-height: 70px;
            line-height: 70px;
            left: 16px;
        `};

    &:focus {
        outline: none;
    }
`;

const Text = styled.span`
    font-family: Averta;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 2px;
    text-align: center;
    color: #333;
    line-height: 100%;
`;

const LinkButton = props => (
    <Button {...props} height={props.height} onClick={props.onClick} theme={useContext(ThemeContext)}>
        <Text>{props.label}</Text>
    </Button>
);

LinkButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    height: PropTypes.number,
    label: PropTypes.string.isRequired
};

export default LinkButton;
